export default [
	    {
	        "id": "ratings__date",
	        "header": "Date",
	        "fieldName": "ratings__date",
	        "isSortable": true,
	        "isEditable": true,
	        "isReorderable": true,
	        "isResizable": true,
	        "w": 150 // MOD
	    },
	    {
	        "id": "ratings__preview",
	        "header": "Preview",
	        "fieldName": "ratings__preview",
	        "isSortable": false,
	        "isEditable": false,
	        "isReorderable": true,
	        "isResizable": true,
	        "w": 450 // MOD
	    },
	    {
	        "id": "ratings__value",
	        "header": "Value",
	        "fieldName": "ratings__value",
	        "isSortable": true,
	        "isEditable": true,
	        "isReorderable": true,
	        "isResizable": true,
	        "w": 100
	    }
	];